import template from './was-this-useful-result.component.html';
var WasThisUsefulResultComponentController = /** @class */ (function () {
    function WasThisUsefulResultComponentController() {
    }
    WasThisUsefulResultComponentController.$inject = [];
    return WasThisUsefulResultComponentController;
}());
export var WasThisUsefulResultComponent = {
    bindings: {},
    controller: WasThisUsefulResultComponentController,
    template: template,
};
